import platform from 'platform'
import { mapState, mapGetters } from 'vuex'

import { PAYEE } from '@/CONSTS'
import * as type from '@/utvStore/store/mutation-types'

export default {
  data() {
    return {
      csrfToken: window.Laravel.csrfToken,
      cpno: window.Laravel.cpno,
      token: '',
      tokenKey: '',
      maskedCcNumber: ''
    }
  },
  props: {
    sbpsApiUrl: String,
    acceptCharset: String,
    formParam: Object,
    merchantId: String,
    serviceId: String,
    orderId: String,
    docomoInformalPaymentArray: Object,
    kddiInformalPaymentArray: Object,
    softbankInformalPaymentArray: Object
  },
  methods: {
    getPaymentData() {
      if (this.auth.accessToken) {
        const data = { access_token: this.auth.accessToken }
        this.$store.dispatch(type.GET_PAYMENT_HISTORY, data)
        this.$store.dispatch(type.GET_PAYMENT_INFO, data)
      }
    },
    /**
     * 決済を実行する
     * @param {event} $event - イベントオブジェクト
     * @param {Stirng} payee - 決済の方法
     */
    executeSettlement($event, payee) {
      // IEの場合はcharsetを変更
      if (this.isCarrierPayment(payee) && platform.name === 'IE') {
        window.document.charset = this.acceptCharset
      }
      $event.target.submit()
    },
    afterGenerateToken(response) {
      if (response.result == 'OK') {
        this.sbpsPaymentError = false
        this.sbpsErrorMessage = {}
        const { tokenResponse } = response
        this.token = tokenResponse.token
        this.tokenKey = tokenResponse.tokenKey
        this.maskedCcNumber = tokenResponse.maskedCcNumber
        this.$refs.form.submit()
      }
    },
    /**
     * キャリア決済かどうかを判定する
     * @param {String} payeeCode - 決済のsbpsのコード
     * @return {Boolean}
     */
    isCarrierPayment(payeeCode) {
      const carrierPaymentCodes = [
        PAYEE.DOCOMO_CODE,
        PAYEE.KDDI_CODE,
        PAYEE.SOFTBANK_CODE
      ]
      return carrierPaymentCodes.includes(payeeCode)
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      payment: state => state.payment
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/Payment/payment-mixins.js